import * as assert from 'assert';
import { ApiService } from './ApiService';

export abstract class CrudService<T, C extends object, U extends object> extends ApiService {
    public create(newRecord: C): Promise<undefined | number | string> {
        return this.postRequest(newRecord).then((response) => {
            if (typeof response.id === 'number') {
                return response.id;
            } else if (typeof response._id === 'string') {
                return response._id;
            } else {
                return undefined;
            }
        });
    }

    public getAll(): Promise<Array<T>> {
        return this.getRequest().then((response: Array<any>) => {
            if (Array.isArray(response)) {
                return this.assembleInstances(response);
            } else {
                assert(false, 'AbstractCRUDService - getAll : unexpected response from server');
            }

            return [] as Array<T>;
        });
    }

    public getById(id: number | string): Promise<T> {
        console.assert(id, 'Paramater is undefined');

        return this.getSubPath(id.toString()).then((response: object) => {
            return this.assembleSingleInstance(response);
        });
    }

    public updateById(id: number | string, updatedRecord: U): Promise<void> {
        console.assert(id, 'Paramater is undefined');
        assert(updatedRecord, 'updatedRecord was undefined');
        return this.putSubPath(id.toString(), updatedRecord).then((response) => {
            return;
        });
    }

    public deleteById(id: number | string): Promise<void> {
        console.assert(id, 'Paramater is undefined');
        return this.deleteSubPath(id.toString()).then((response) => {
            return;
        });
    }

    protected abstract assembleInstances(response: Array<any>): Array<T>;

    protected abstract assembleSingleInstance(response: any): T;
}



// WEBPACK FOOTER //
// ./src/_services/CrudService.ts